<template>
  <v-container>
    <v-card flat style="border-radius: 0">
      <v-card-text class="px-3">
        <h5 style="display: inline-block">Modificar Cajero ATM</h5>
      </v-card-text>
      <v-card-text>
        <v-layout row wrap>
            <div
               v-if="loader.cajero"
              style="position: absolute; background: rgba( 255,255,255,0.7 ); width: 100%; height: 100%;"
            >
              <v-progress-circular
                indeterminate
                color="primary"
                :size="50"
                style="position: absolute; top: 50%; left: 50%; transform: translate( -50%, -50% );"
              ></v-progress-circular>
            </div>

            <v-flex md12 sm12 class="pr-2">
              <h5>Datos de ATM</h5>
            </v-flex>
            <v-flex md12 sm12 class="pr-2">
              <v-text-field label="ID ATM" v-model="cajero.agents" ></v-text-field>
            </v-flex>
            <v-flex md6 sm12 class="pr-2">
              <v-text-field label="Nombre" v-model="cajero.name" ></v-text-field>
            </v-flex>
            <v-flex md6 sm12 class="pr-2">
              <v-text-field label="Dirección" v-model="cajero.direction" ></v-text-field>
            </v-flex>

            <v-flex xs12 md12 lg12 class="pr-2">
            <v-select
            @change="getProvincias()"
            single-line
            hide-details
            return-object
              menu-props="auto"
              :items="selectDepartaments"
              label="Filtrar Departamento"
              item-text="nombre"
              item-value="nombre"
              v-model="cajero.department"
            ></v-select>
          </v-flex> 

          <v-flex xs12 md12 lg12 class="pr-2">
            <v-select
            @change="getDistritos()"
            single-line
            hide-details
            return-object
            menu-props="auto"
              :items="selectProvincias"
              label="Filtrar Provincia"
              item-text="nombre"
              v-model="cajero.province"
            ></v-select>
          </v-flex> 
           
          <v-flex xs12 md12 lg12 class="pr-2">
            <v-select
            single-line
            hide-details
            return-object
            menu-props="auto"
              :items="selectDistrict"
              label="Filtrar Distrito"
              item-text="nombre"
              v-model="cajero.district"
            ></v-select>
          </v-flex> 

            <v-flex md12 sm12 class="pr-2">
              <v-text-field label="Referencia" v-model="cajero.reference" ></v-text-field>
            </v-flex>
            <v-flex md12 sm12 class="pr-2">
              <v-text-field label="Horario de Atención" v-model="cajero.schedule" ></v-text-field>
            </v-flex>
            <v-flex md12 sm12 class="pr-2">
              <v-text-field label="RUC" v-model="cajero.ruc" ></v-text-field>
            </v-flex>
            <v-flex md6 sm12 class="pr-2">
              <v-text-field label="Representante" v-model="cajero.representative" ></v-text-field>
            </v-flex>
            <v-flex md6 sm12 class="pr-2">
              <v-text-field label="Telefonos" v-model="cajero.phone" ></v-text-field>
            </v-flex>
            <v-flex md12 sm12 class="pr-2">
              <v-text-field label="Email" v-model="cajero.mail" ></v-text-field>
            </v-flex>

             <v-flex md12 sm12 >
                <div class="text-right" align="right">
                	<v-btn @click="close()" :disabled="loader.btnModificar" color="error">Cerrar</v-btn>
                	<v-btn @click="modificar()" :loading="loader.btnModificar" color="success">MODIFICAR</v-btn>
                </div>
            </v-flex>

            
         
        </v-layout>
      </v-card-text>
    </v-card>
    <v-snackbar v-model="snackbar.show" :color="snackbar.color" bottom right :timeout="2000">
      <v-icon>{{ snackbar.icon }}</v-icon>
      &nbsp;
      {{ snackbar.text }}
      <v-btn flat @click="snackbar.show = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import moment from "moment";
import axios from "@/api/axios/config";
import base_url from "@/api/axios/base_url";
import vueDropzone from "vue2-dropzone";

export default {
  components: {
    vueDropzone
  },
  data() {
    return {

      loader: {
        btnModificar: false,
        cajero:false
      },
      snackbar: {
        icon: "",
        text: "",
        color: "",
        show: false
      },
      selectDepartaments:[],
      selectProvincias:[],
      selectDistrict:[],
      cajero:{
      	name:'',
      	direction:'',
      	department:'',
		district:'',
		province:'',
		reference:'',
		schedule:'',
		agents:'',
		ruc:'',
		representative:'',
		phone:'',
		mail:''
      }

    };
  },
  

  methods: {


  	recibirData() {

      this.loader.saveBtn = true;
      axios
        .get("gn/cajero-gn/find/" + this.$route.params.id)
        .then(response => {
          if (response.data.status) {
            let item = response.data.item;
            

            this.cajero.name = item.name;
            this.cajero.direction = item.direction;
            this.cajero.department = item.department;
            this.cajero.district = item.district;
            this.cajero.province = item.province;
            this.cajero.reference = item.reference;
            this.cajero.schedule = item.schedule;
            this.cajero.agents = item.agents;
            this.cajero.ruc = item.ruc;
            this.cajero.representative = item.representative;
            this.cajero.phone = item.phone;
            this.cajero.mail = item.mail;

            this.selectDepartaments.forEach((element) => {
            	if (element.nombre.toLowerCase().trim() === item.department.toLowerCase().trim()) {
            		this.cajero.department = element;
            		this.getProvinciasAutomatico(element.iddepartamento,this.cajero.province);
            	}
            });


           

          } else {
            this.close();
          }
        })
        .catch(err => {
          this.snackbar = {
            icon: "error",
            text: "No se encontro el registro",
            color: "success",
            show: true
          };
          this.close();
        })
        .finally(() => {
          this.loader.btnModificar = false;
        });
    },

  	modificar() {
      this.loader.btnModificar = true;
      this.loader.cajero = true;
      axios
        .put("gn/cajero-gn/modificar/"+this.$route.params.id, this.cajero)
        .then(response => {
          if (response.status) {
            this.snackbar = {
              icon: "check_circle",
              text: "¡Cajero ATM modificado!",
              color: "success",
              show: true
            };
            setTimeout(() => {
              this.close();
            }, 2000);
          } else {
            this.snackbar = {
              icon: "error",
              text: "Ocurrió un error en el servidor",
              color: "success",
              show: true
            };
            this.loader.btnModificar = false;
            this.loader.cajero = false;
          }
        })
        .catch(err => {
          this.snackbar = {
            icon: "error",
            text: err,
            color: "success",
            show: true
          };
          this.loader.btnModificar = false;
          this.loader.cajero = false;
        });
    },




   

  	getDepartamentos() {
      axios
        .get(
          "ubigeo/listDepartamentos"
        )
        .then(response => {
           this.selectDepartaments = response.data.data;


        })
        .catch(error => {
          console.log(error);
        });
    },

    getProvincias(){
      this.selectDistrict = [];
      axios
        .get(
          "ubigeo/listProvincias?iddepartamento="+this.cajero.department.iddepartamento
        )
        .then(response => {
           this.selectProvincias = response.data.data;
        })
        .catch(error => {
          console.log(error);
        });

    },

   

    getDistritos(){
      axios
        .get(
          "ubigeo/listDistritos?idprovincia="+this.cajero.province.idprovincia
        )
        .then(response => {
           this.selectDistrict = response.data.data;
        })
        .catch(error => {
          console.log(error);
        });

    },


     getProvinciasAutomatico(iddepartamento,provinciaActual){
      this.selectDistrict = [];
      axios
        .get(
          "ubigeo/listProvincias?iddepartamento="+iddepartamento
        )
        .then(response => {
           this.selectProvincias = response.data.data;
	
           this.selectProvincias.forEach((element) => {
            	if (element.nombre.toLowerCase().trim() === provinciaActual.toLowerCase().trim()) {
            		this.cajero.province = element;
            		this.getDistritoAutomatico(element.idprovincia,this.cajero.district);
            	}
            });

        })
        .catch(error => {
          console.log(error);
        });

    },

     getDistritoAutomatico(idprovincia,distritoActual){
      axios
        .get(
          "ubigeo/listDistritos?idprovincia="+idprovincia
        )
        .then(response => {
           this.selectDistrict = response.data.data;
	
           this.selectDistrict.forEach((element) => {
            	if (element.nombre.toLowerCase().trim() === distritoActual.toLowerCase().trim()) {
            		this.cajero.district = element;
            	}
            });

        })
        .catch(error => {
          console.log(error);
        });

    },
  
  close(){
  		this.$router.push("/GN/cajero-gn/listado");
  }
  
  },

  created(){
  	this.getDepartamentos();
  	this.recibirData();
  	
  }



};
</script>

<style scoped>
.dragzone {
  border: dashed 2px #bbb;
  border-radius: 10px;
}
.locate-middle {
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translateY(-50%);
  color: #bbb;
}
#drop1 {
  cursor: pointer;
  height: auto;
  padding: 40px;
  border: dashed 2px #bbb;
  color: #bbb;
  font-size: 17px;
  background: transparent;
  border-radius: 10px;
}
#drop1 .dz-preview {
  width: 40%;
}

.dz-image,
.dz-details {
  border-radius: 5px !important;
}
</style>